import { getParam } from "./getParam";

export const showAgePopup = () => {
  const uid = getParam('uid');

  if (document.cookie.split(';').some((item) => item.trim().startsWith(`ageVerified-${uid}=`))) {
    return;
  }

  const agePopup = `
    <div class="age-overlay">
      <div class="age-popup">
        <h2>Are you over 21?</h2>
        <p>You must be 21 years of age or older to view page. Please verify your age to enter.</p>
        <div class="age-buttons">
          <button class="age-yes">Yes</button>
          <button class="age-no">No</button>
        </div>
      </div>
    </div>
  `;
  $('body').append(agePopup);

  document.querySelector('.age-yes').addEventListener('click', () => {
    const d = new Date();
    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `ageVerified-${uid}=true; ${expires}; path=/`;
    document.querySelector('.age-overlay').remove();
  });

  document.querySelector('.age-no').addEventListener('click', () => {
    window.location.href = "https://www.google.com";
  });
};
